import { Component, OnInit, ViewChild, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { MatDialog, MatPaginator, MatTableDataSource, MatSort, Sort, MatAutocompleteTrigger, PageEvent } from '@angular/material';
import { DateTime } from "luxon";

@Component({
  selector: 'app-odc-dashboard',
  templateUrl: './odc-dashboard.component.html',
  styleUrls: ['./odc-dashboard.component.scss']
})
export class OdcDashboardComponent implements OnInit {
  @ViewChild('approveDisapproveDialog', { static: true }) approveDisapproveDialog: TemplateRef<any>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  totalOdcCount = 0;
  isImage = false;
  isPdf = false;
  extension: any;
  previewImage: any;
  approveDialogRef: any;
  dialogData: any;
  updateComments='';
  elementType: any;
  constructor(
    private http: HttpService,
    private snackbar: SnackbarService,
    private dialog: MatDialog,
  ) { }

  showLoader: any;
  minDate: any;
  fromDate: any;
  toDate: any;
  odcDatasource: any = [];
  dialogRef: any;
  mwgArray; any;
  displayedColumns = [
    'sno',
    'sin',
    'pickup',
    'odNo',
    'odcRequest',
    'carrierComment',
    'shipperComment',
    'attachments',
  ]
  statuses = ['Approved', 'Pending', 'Disapproved'];
  searchWithOptions = [
    {
      name: 'OD No.',
      type: 'odNo'
    },
    {
      name: 'SIN No.',
      type: 'sinNo'
    }
  ];
  selectedSIN: any;
  selectedVehicle: any;
  selectedDo: any;
  selectedStatus = 'Pending';
  selectedSearch: any;
  odcFilter: any = {
    limit: 0,
    skip: 0,
  };
  pageEvent: PageEvent;
  previewPdf: any = '';
  inputSearch:any ='';
  ngOnInit(): void {
    this.getOdcDetails();
    this.selectedSearch = this.searchWithOptions[0];
  }

  getOdcDetails(filter: any = {}) {
    this.odcDatasource =[];
    filter = {
      ...(this.fromDate && { from: DateTime.fromJSDate(this.fromDate).startOf("day").toUTC() }),
      ...(this.toDate && { to: DateTime.fromJSDate(this.toDate).endOf("day").toUTC() }),
      ...(this.selectedStatus && { status: this.selectedStatus.toLocaleUpperCase() }),
      // ...(this.selectedSIN && { sin: this.selectedSIN }),
      // ...(this.selectedVehicle && { vehicle: this.selectedVehicle }),
      // ...(this.selectedDo && { doNumber: this.selectedDo }),
    };
    if (this.selectedSearch && this.selectedSearch.type && this.inputSearch) {
      if (this.selectedSearch.type === 'odNo') {
        filter.do_number = this.inputSearch;
      } else if (this.selectedSearch.type === 'sinNo') {
        filter.sin = this.inputSearch;
      }
    }
    filter.limit = this.paginator.pageSize || 10;
    filter.skip = this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);
    this.http.get('getAllOdc', filter, 2).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          const res = data.data.odc;
          this.totalOdcCount = data.data.count;
          res.forEach((element)=>{
            const temp:any = {}
            temp._id = element._id
            temp.sin = element.shipment.SIN;
            temp.pickups = element.shipment.pickups;
            temp.deliveries = element.shipment.deliveries;
            temp.status = element.status;
            temp.do_numbers = element.do_numbers.join(' ,');
            temp.attachments = element.attachments;
            temp.carrier_comments = element.carrier_comments ? element.carrier_comments : '---',
            temp.shipper_comments = element.shipper_comments ? element.shipper_comments : '---',
            temp.attachments = temp.attachments.filter((attachmentUrl: string) => {
              const extension = attachmentUrl.split('.').pop();
              return extension === 'pdf'; 
            });
            console.log(this.extension)
            if (temp.attachments.length > 0) {
              this.isPdf = true;
              this.previewPdf = temp.attachments[0];
            } else {
              this.isImage = true;
              this.previewImage = temp.attachments[0];
            }
            this.odcDatasource.push(temp);
          });
        }

      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  selectStatus(element) {
    this.selectedStatus = element;
    this.getOdcDetails();
  }

  pageNavigate(event: PageEvent) {
    this.odcFilter.limit = event.pageSize;
    this.odcFilter.skip = event.pageIndex * event.pageSize;
    this.getOdcDetails(this.odcFilter);
  }
  getStatusStyles(status: string) {
    let backgroundColor = '';
    let textColor = '';
    switch (status.toLowerCase()) {
      case 'pending':
        backgroundColor = '#F08D321F';
        textColor = '#F08D32';
        break;
      case 'approved':
        backgroundColor = '#08BD801F';
        textColor = '#08BD80';
        break;
      case 'disapproved':
        backgroundColor = '#E64F4F1F';
        textColor = '#E64F4F';
        break;
      default:
        backgroundColor = 'white';
        textColor = 'black';
    }

    return {
      'background-color': backgroundColor,
      'color': textColor
    };
  }
  openImagePopup() {
    document.getElementById("myPopup").style.display = "block";
  }

  closePopup() {
    document.getElementById("myPopup").style.display = "none";
  }
  submitSearch(){
    this.getOdcDetails();
  }
}
